import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EdgesensorHighIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edgesensor_high"}/>
}
